// extracted by css-extract-rspack-plugin
export default {"appShellMain":"appShellMain-r870xl"};